export default __webpack_public_path__ + "static/media/poem name@2x.8d08dd61.png";